import { Product } from '../types';

// ============================================
// HEAT SHRINK SLEEVES & PROTECTIVE SLEEVES
// ============================================

// HEAT SHRINK SLEEVES - Comprehensive Range
// export const heatShrinkSleeveProducts: Product[] = [
//   {
//     id: "heat-shrink-range",
//     name: "Heat Shrink Sleeve (Tube) - Complete Range",
//     slug: "heat-shrink-sleeve-complete-range",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Complete range of heat shrink sleeves/tubes from 0.6mm to 180mm diameter. Available in Black, Transparent/Clear, White, Red, Green, Yellow, and Blue colors. 2:1 shrink ratio for excellent insulation and protection.",
//     featured: true,
//     partNumber: "SI0300001-SI0300180",
//     specifications: {
//       "Available Sizes": "0.6mm, 0.8mm, 1mm, 1.5mm, 2mm, 2.5mm, 3mm, 3.5mm, 4mm, 4.5mm, 5mm, 5.5mm, 6mm (Round & Flat), 7mm-180mm",
//       "Colors": "Black, Transparent/Clear, White, Red, Green, Yellow, Blue",
//       "Shrink Ratio": "2:1",
//       "Material": "Polyolefin",
//       "Temperature Range": "-55°C to +125°C",
//       "Packing": "Varies by size (see individual sizes)",
//     },
//     tags: ["heat-shrink", "sleeve", "insulation", "tube", "all-colors"],
//     applications: ["Wire Insulation", "Cable Repair", "Terminal Protection", "Automotive", "Electronics"],
//   },
//   // Small Diameter Heat Shrinks (0.6mm - 3mm)
//   {
//     id: "heat-shrink-0.6mm",
//     name: "Heat Shrink Sleeve - 0.6mm (SM1)",
//     slug: "heat-shrink-sleeve-0.6mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Ultra-thin heat shrink sleeve, 0.6mm diameter. Perfect for fine wiring and small terminals. Black: 23 rolls/box (200m/roll, 4600m total). Color: 18 rolls/box (400m/roll, 7200m total).",
//     partNumber: "SI030SM01",
//     specifications: {
//       "Diameter": "0.6mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "23 rolls × 200m = 4600m per box",
//       "Color Packing": "18 rolls × 400m = 7200m per box",
//     },
//     tags: ["heat-shrink", "0.6mm", "ultra-thin"],
//     applications: ["Electronics", "Fine Wiring", "Micro Connections"],
//   },
//   {
//     id: "heat-shrink-0.8mm",
//     name: "Heat Shrink Sleeve - 0.8mm (SM2)",
//     slug: "heat-shrink-sleeve-0.8mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Ultra-thin heat shrink sleeve, 0.8mm diameter. Black: 23 rolls/box (200m/roll, 4600m). Color: 18 rolls/box (400m/roll, 7200m).",
//     partNumber: "SI030SM02",
//     specifications: {
//       "Diameter": "0.8mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "23 rolls × 200m = 4600m",
//       "Color Packing": "18 rolls × 400m = 7200m",
//     },
//     tags: ["heat-shrink", "0.8mm", "ultra-thin"],
//     applications: ["Electronics", "Fine Wiring"],
//   },
//   {
//     id: "heat-shrink-1mm",
//     name: "Heat Shrink Sleeve - 1mm",
//     slug: "heat-shrink-sleeve-1mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 1mm diameter. Black: 16 rolls/box (200m/roll, 3200m). Color: 10 rolls/box (400m/roll, 4000m).",
//     partNumber: "SI0300001",
//     featured: true,
//     specifications: {
//       "Diameter": "1mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "16 rolls × 200m = 3200m",
//       "Color Packing": "10 rolls × 400m = 4000m",
//     },
//     tags: ["heat-shrink", "1mm"],
//     applications: ["Automotive", "Electronics"],
//   },
//   {
//     id: "heat-shrink-1.5mm",
//     name: "Heat Shrink Sleeve - 1.5mm",
//     slug: "heat-shrink-sleeve-1.5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 1.5mm diameter. Black: 12 rolls/box (200m/roll, 2400m). Color: 8 rolls/box (400m/roll, 3200m).",
//     partNumber: "SI0300001.5",
//     specifications: {
//       "Diameter": "1.5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "12 rolls × 200m = 2400m",
//       "Color Packing": "8 rolls × 400m = 3200m",
//     },
//     tags: ["heat-shrink", "1.5mm"],
//     applications: ["Automotive", "Wire Harness"],
//   },
//   {
//     id: "heat-shrink-2mm",
//     name: "Heat Shrink Sleeve - 2mm",
//     slug: "heat-shrink-sleeve-2mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 2mm diameter. Black: 15 rolls/box (200m/roll, 3000m). Color: 10 rolls/box (400m/roll, 4000m).",
//     partNumber: "SI0300002",
//     featured: true,
//     specifications: {
//       "Diameter": "2mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "15 rolls × 200m = 3000m",
//       "Color Packing": "10 rolls × 400m = 4000m",
//     },
//     tags: ["heat-shrink", "2mm"],
//     applications: ["Automotive", "Wire Harness"],
//   },
//   {
//     id: "heat-shrink-2.5mm",
//     name: "Heat Shrink Sleeve - 2.5mm",
//     slug: "heat-shrink-sleeve-2.5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 2.5mm diameter. Black: 13 rolls/box (200m/roll, 2600m). Color: 8 rolls/box (400m/roll, 3200m).",
//     partNumber: "SI0300002.5",
//     specifications: {
//       "Diameter": "2.5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "13 rolls × 200m = 2600m",
//       "Color Packing": "8 rolls × 400m = 3200m",
//     },
//     tags: ["heat-shrink", "2.5mm"],
//     applications: ["Automotive", "Wire Protection"],
//   },
//   {
//     id: "heat-shrink-3mm",
//     name: "Heat Shrink Sleeve - 3mm",
//     slug: "heat-shrink-sleeve-3mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 3mm diameter. Black: 11 rolls/box (200m/roll, 2200m). Color: 6 rolls/box (400m/roll, 2400m).",
//     partNumber: "SI0300003",
//     featured: true,
//     specifications: {
//       "Diameter": "3mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "11 rolls × 200m = 2200m",
//       "Color Packing": "6 rolls × 400m = 2400m",
//     },
//     tags: ["heat-shrink", "3mm"],
//     applications: ["Automotive", "Wire Protection"],
//   },
//   // Medium Diameter Heat Shrinks (3.5mm - 6mm)
//   {
//     id: "heat-shrink-3.5mm",
//     name: "Heat Shrink Sleeve - 3.5mm",
//     slug: "heat-shrink-sleeve-3.5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 3.5mm diameter. Black: 9 rolls/box (200m/roll, 1800m). Color: 5 rolls/box (400m/roll, 2000m).",
//     partNumber: "SI0300003.5",
//     specifications: {
//       "Diameter": "3.5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "9 rolls × 200m = 1800m",
//       "Color Packing": "5 rolls × 400m = 2000m",
//     },
//     tags: ["heat-shrink", "3.5mm"],
//     applications: ["Automotive", "Cable Protection"],
//   },
//   {
//     id: "heat-shrink-4mm",
//     name: "Heat Shrink Sleeve - 4mm",
//     slug: "heat-shrink-sleeve-4mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 4mm diameter. Black: 7 rolls/box (200m/roll, 1400m). Color: 4 rolls/box (400m/roll, 1600m).",
//     partNumber: "SI0300004",
//     featured: true,
//     specifications: {
//       "Diameter": "4mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "7 rolls × 200m = 1400m",
//       "Color Packing": "4 rolls × 400m = 1600m",
//     },
//     tags: ["heat-shrink", "4mm"],
//     applications: ["Automotive", "Cable Protection"],
//   },
//   {
//     id: "heat-shrink-4.5mm",
//     name: "Heat Shrink Sleeve - 4.5mm",
//     slug: "heat-shrink-sleeve-4.5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 4.5mm diameter. Black: 10 rolls/box (100m/roll, 1000m). Color: 6 rolls/box (200m/roll, 1200m).",
//     partNumber: "SI0300004.5",
//     specifications: {
//       "Diameter": "4.5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "10 rolls × 100m = 1000m",
//       "Color Packing": "6 rolls × 200m = 1200m",
//     },
//     tags: ["heat-shrink", "4.5mm"],
//     applications: ["Automotive", "Cable Protection"],
//   },
//   {
//     id: "heat-shrink-5mm",
//     name: "Heat Shrink Sleeve - 5mm",
//     slug: "heat-shrink-sleeve-5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 5mm diameter. Black: 9 rolls/box (100m/roll, 900m). Color: 5 rolls/box (200m/roll, 1000m).",
//     partNumber: "SI0300005",
//     featured: true,
//     specifications: {
//       "Diameter": "5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "9 rolls × 100m = 900m",
//       "Color Packing": "5 rolls × 200m = 1000m",
//     },
//     tags: ["heat-shrink", "5mm"],
//     applications: ["Automotive", "Cable Bundling"],
//   },
//   {
//     id: "heat-shrink-5.5mm",
//     name: "Heat Shrink Sleeve - 5.5mm",
//     slug: "heat-shrink-sleeve-5.5mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 5.5mm diameter. Black: 8 rolls/box (100m/roll, 800m). Color: 5 rolls/box (200m/roll, 1000m).",
//     partNumber: "SI0300005.5",
//     specifications: {
//       "Diameter": "5.5mm",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "8 rolls × 100m = 800m",
//       "Color Packing": "5 rolls × 200m = 1000m",
//     },
//     tags: ["heat-shrink", "5.5mm"],
//     applications: ["Automotive", "Cable Bundling"],
//   },
//   {
//     id: "heat-shrink-6mm-round",
//     name: "Heat Shrink Sleeve - 6mm Round",
//     slug: "heat-shrink-sleeve-6mm-round",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 6mm diameter (Round). Black: 7 rolls/box (100m/roll, 700m). Color: 4 rolls/box (200m/roll, 800m).",
//     partNumber: "SI0300006R",
//     featured: true,
//     specifications: {
//       "Diameter": "6mm",
//       "Shape": "Round",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "7 rolls × 100m = 700m",
//       "Color Packing": "4 rolls × 200m = 800m",
//     },
//     tags: ["heat-shrink", "6mm", "round"],
//     applications: ["Automotive", "Heavy Duty Cable"],
//   },
//   {
//     id: "heat-shrink-6mm-flat",
//     name: "Heat Shrink Sleeve - 6mm Flat",
//     slug: "heat-shrink-sleeve-6mm-flat",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 6mm flat profile. Black: 15 rolls/box (100m/roll, 1500m).",
//     partNumber: "SI0300006F",
//     specifications: {
//       "Diameter": "6mm",
//       "Shape": "Flat",
//       "Shrink Ratio": "2:1",
//       "Black Packing": "15 rolls × 100m = 1500m",
//     },
//     tags: ["heat-shrink", "6mm", "flat"],
//     applications: ["Automotive", "Flat Cable"],
//   },
//   // Large Diameter Heat Shrinks (7mm - 25mm)
//   {
//     id: "heat-shrink-7mm",
//     name: "Heat Shrink Sleeve - 7mm",
//     slug: "heat-shrink-sleeve-7mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 7mm diameter. Black: 14 rolls/box (100m/roll, 1400m).",
//     partNumber: "SI0300007",
//     specifications: {
//       "Diameter": "7mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "14 rolls × 100m = 1400m per box",
//     },
//     tags: ["heat-shrink", "7mm"],
//     applications: ["Automotive", "Heavy Duty"],
//   },
//   {
//     id: "heat-shrink-8mm",
//     name: "Heat Shrink Sleeve - 8mm",
//     slug: "heat-shrink-sleeve-8mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 8mm diameter. Black: 13 rolls/box (100m/roll, 1300m).",
//     partNumber: "SI0300008",
//     featured: true,
//     specifications: {
//       "Diameter": "8mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "13 rolls × 100m = 1300m per box",
//     },
//     tags: ["heat-shrink", "8mm"],
//     applications: ["Automotive", "Heavy Duty"],
//   },
//   {
//     id: "heat-shrink-9mm",
//     name: "Heat Shrink Sleeve - 9mm",
//     slug: "heat-shrink-sleeve-9mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 9mm diameter. Black: 12 rolls/box (100m/roll, 1200m).",
//     partNumber: "SI0300009",
//     specifications: {
//       "Diameter": "9mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "12 rolls × 100m = 1200m per box",
//     },
//     tags: ["heat-shrink", "9mm"],
//     applications: ["Automotive", "Heavy Duty"],
//   },
//   {
//     id: "heat-shrink-10mm",
//     name: "Heat Shrink Sleeve - 10mm",
//     slug: "heat-shrink-sleeve-10mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 10mm diameter. Black: 11 rolls/box (100m/roll, 1100m).",
//     partNumber: "SI0300010",
//     featured: true,
//     specifications: {
//       "Diameter": "10mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "11 rolls × 100m = 1100m per box",
//     },
//     tags: ["heat-shrink", "10mm"],
//     applications: ["Automotive", "Commercial Vehicles"],
//   },
//   {
//     id: "heat-shrink-12mm",
//     name: "Heat Shrink Sleeve - 12mm",
//     slug: "heat-shrink-sleeve-12mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 12mm diameter. Black: 10 rolls/box (100m/roll, 1000m).",
//     partNumber: "SI0300012",
//     featured: true,
//     specifications: {
//       "Diameter": "12mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "10 rolls × 100m = 1000m per box",
//     },
//     tags: ["heat-shrink", "12mm"],
//     applications: ["Automotive", "Commercial Vehicles"],
//   },
//   {
//     id: "heat-shrink-15mm",
//     name: "Heat Shrink Sleeve - 15mm",
//     slug: "heat-shrink-sleeve-15mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 15mm diameter. Black: 8 rolls/box (100m/roll, 800m).",
//     partNumber: "SI0300015",
//     specifications: {
//       "Diameter": "15mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "8 rolls × 100m = 800m per box",
//     },
//     tags: ["heat-shrink", "15mm"],
//     applications: ["Commercial Vehicles", "Heavy Duty"],
//   },
//   {
//     id: "heat-shrink-20mm",
//     name: "Heat Shrink Sleeve - 20mm",
//     slug: "heat-shrink-sleeve-20mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 20mm diameter. Black: 6 rolls/box (100m/roll, 600m).",
//     partNumber: "SI0300020",
//     featured: true,
//     specifications: {
//       "Diameter": "20mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "6 rolls × 100m = 600m per box",
//     },
//     tags: ["heat-shrink", "20mm"],
//     applications: ["Commercial Vehicles", "Heavy Duty"],
//   },
//   {
//     id: "heat-shrink-25mm",
//     name: "Heat Shrink Sleeve - 25mm",
//     slug: "heat-shrink-sleeve-25mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 25mm diameter. Black: 6 rolls/box (50m/roll, 300m).",
//     partNumber: "SI0300025",
//     specifications: {
//       "Diameter": "25mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "6 rolls × 50m = 300m per box",
//     },
//     tags: ["heat-shrink", "25mm"],
//     applications: ["Commercial Vehicles", "Industrial"],
//   },
//   // Extra Large Diameter Heat Shrinks (30mm - 180mm)
//   {
//     id: "heat-shrink-30mm",
//     name: "Heat Shrink Sleeve - 30mm",
//     slug: "heat-shrink-sleeve-30mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 30mm diameter. Black: 5 rolls/box (50m/roll, 250m).",
//     partNumber: "SI0300030",
//     specifications: {
//       "Diameter": "30mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "5 rolls × 50m = 250m per box",
//     },
//     tags: ["heat-shrink", "30mm", "large"],
//     applications: ["Industrial", "Heavy Machinery"],
//   },
//   {
//     id: "heat-shrink-40mm",
//     name: "Heat Shrink Sleeve - 40mm",
//     slug: "heat-shrink-sleeve-40mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 40mm diameter. Black: 4 rolls/box (50m/roll, 200m).",
//     partNumber: "SI0300040",
//     specifications: {
//       "Diameter": "40mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "4 rolls × 50m = 200m per box",
//     },
//     tags: ["heat-shrink", "40mm", "large"],
//     applications: ["Industrial", "Heavy Machinery"],
//   },
//   {
//     id: "heat-shrink-50mm",
//     name: "Heat Shrink Sleeve - 50mm",
//     slug: "heat-shrink-sleeve-50mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 50mm diameter. Black: 5 rolls/box (25m/roll, 125m).",
//     partNumber: "SI0300050",
//     featured: true,
//     specifications: {
//       "Diameter": "50mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "5 rolls × 25m = 125m per box",
//     },
//     tags: ["heat-shrink", "50mm", "extra-large"],
//     applications: ["Industrial", "Power Distribution"],
//   },
//   {
//     id: "heat-shrink-100mm",
//     name: "Heat Shrink Sleeve - 100mm",
//     slug: "heat-shrink-sleeve-100mm",
//     category: "Heat Shrink & Sleeves",
//     subcategory: "Heat Shrink Sleeve",
//     description: "Heat shrink sleeve, 100mm diameter. Black: 2 rolls/box (25m/roll, 50m).",
//     partNumber: "SI0300100",
//     specifications: {
//       "Diameter": "100mm",
//       "Shrink Ratio": "2:1",
//       "Packing": "2 rolls × 25m = 50m per box",
//     },
//     tags: ["heat-shrink", "100mm", "extra-large"],
//     applications: ["Industrial", "Power Distribution", "Heavy Duty"],
//   },
// ];

export const heatShrinkSleeveProducts: Product[] = [];

export const busbarSleeveProducts: Product[] = [
  {
    id: "busbar-sleeve-red",
    name: "Busbar Sleeve - Red",
    slug: "busbar-sleeve-red",
    category: "Heat Shrink & Sleeves",
    subcategory: "Busbar Sleeve",
    description:
      "High-quality PVC Busbar Sleeve for electrical insulation and protection. Available in diameters ranging from 15mm to 210mm. Standard roll length is 25 meters (20 meters for 210mm size). Supplied in red color.",
    image: "/products/heat-shrink-sleeves/sleeve/2-busbar-sleeve.jpg",
    partNumber: "SI0310015-SI0310210",
    featured: true,
    specifications: {
      Material: "PVC",
      Color: "Red",
      Type: "Roll",
      "Diameter Range": "15mm to 210mm",
      "Standard Roll Length": "25 Meters (20 Meters for 210mm)",
      "Box Packing Range": "20 Meters to 200 Meters (Depending on Size)",
    },
    tags: [
      "busbar sleeve",
      "pvc",
      "electrical insulation",
      "red sleeve",
      "industrial",
    ],
    applications: [
      "Busbar Insulation",
      "Electrical Panels",
      "Switchgear Protection",
      "Power Distribution Systems",
      "Industrial Electrical Applications",
    ],
  },
];

// PVC SLEEVES - Shine & Dull
export const pvcSleeveProducts: Product[] = [
  {
    id: "pvc-sleeve-shine-roll",
    name: "PVC Sleeve Roll - Shine Finish",
    slug: "pvc-sleeve-roll-shine",
    category: "Heat Shrink & Sleeves",
    subcategory: "PVC Sleeve",
    description:
      "PVC sleeve roll with shiny finish for electrical insulation and wire identification. Available in sizes ranging from 3mm to 25mm diameter.",
    image: "/products/heat-shrink-sleeves/sleeve/3-shine-sleeve.jpg",
    partNumber: "SI0400003-SI0400025",
    featured: true,
    specifications: {
      Finish: "Shine",
      Material: "PVC",
      Type: "Roll",
      "Size Range": "3mm to 25mm",
      "Available Sizes":
        "3mm, 4mm, 5mm, 6mm, 7mm, 8mm, 9mm, 10mm, 11mm, 12mm, 13mm, 14mm, 15mm, 16mm, 17mm, 18mm, 19mm, 20mm, 21mm, 22mm, 23mm, 24mm, 25mm",
    },
    tags: ["pvc", "sleeve", "shine", "roll", "insulation"],
    applications: [
      "Wire Insulation",
      "Wire Identification",
      "Cable Protection",
      "Electrical Applications",
    ],
  },
  {
    id: "pvc-sleeve-dull-roll",
    name: "PVC Sleeve Roll - Dull Finish",
    slug: "pvc-sleeve-roll-dull",
    category: "Heat Shrink & Sleeves",
    subcategory: "PVC Sleeve",
    description:
      "PVC sleeve roll with dull/matte finish for electrical insulation and cable protection. Available in sizes ranging from 3mm to 25mm diameter.",
    image: "/products/heat-shrink-sleeves/sleeve/4-dull-sleeve.jpg",
    partNumber: "SI0400103-SI0400125",
    featured: true,
    specifications: {
      Finish: "Dull / Matte",
      Material: "PVC",
      Type: "Roll",
      "Size Range": "3mm to 25mm",
      "Available Sizes":
        "3mm, 4mm, 5mm, 6mm, 7mm, 8mm, 9mm, 10mm, 11mm, 12mm, 13mm, 14mm, 15mm, 16mm, 17mm, 18mm, 19mm, 20mm, 21mm, 22mm, 23mm, 24mm, 25mm",
    },
    tags: ["pvc", "sleeve", "dull", "roll", "insulation"],
    applications: [
      "Wire Insulation",
      "Cable Bundling",
      "Electrical Protection",
      "Industrial Use",
    ],
  },
];

// // PVC & COTTON TAPE
export const pvcCottonTapeProducts: Product[] = [
  {
    id: "standard-insulation-tape",
    name: "Standard Insulation Tape",
    slug: "standard-insulation-tape",
    category: "Heat Shrink & Sleeves",
    subcategory: "PVC Tape",
    description:
      "Standard PVC insulation tape for electrical applications. Supplied in bags of 30 pieces.",
    image: "/products/heat-shrink-sleeves/tape/standard-insulation-tape.jpg",
    partNumber: "SI0509900",
    tags: ["pvc tape", "insulation", "standard"],
    specifications: {
      Material: "PVC",
      Packing: "Bag of 30 Pcs",
      Usage: "Electrical Insulation",
    },
    applications: [
      "Electrical Insulation",
      "Wire Bundling",
      "General Purpose",
    ],
  },
  {
    id: "export-insulation-tape",
    name: "Export Insulation Tape",
    slug: "export-insulation-tape",
    category: "Heat Shrink & Sleeves",
    subcategory: "PVC Tape",
    description:
      "Export quality PVC insulation tape designed for professional and international standards. Supplied in bags of 50 pieces.",
    image: "/products/heat-shrink-sleeves/tape/export-insulation-tape.jpg",
    partNumber: "SI0509901",
    tags: ["pvc tape", "export", "insulation"],
    specifications: {
      Material: "PVC",
      Quality: "Export Grade",
      Packing: "Bag of 50 Pcs",
    },
    applications: [
      "Professional Electrical Work",
      "Industrial Use",
      "Export Supply",
    ],
  },
  {
    id: "export-cotton-insulation-tape",
    name: "Export Cotton Insulation Tape",
    slug: "export-cotton-insulation-tape",
    category: "Heat Shrink & Sleeves",
    subcategory: "Cotton Tape",
    description:
      "Export quality cotton insulation tape suitable for high-temperature and wire harness applications. Supplied in bags of 20 pieces.",
    image: "/products/heat-shrink-sleeves/tape/export-cotton-insulation-tape.jpg",
    partNumber: "SI0509993",
    tags: ["cotton tape", "high temperature", "insulation", "export"],
    specifications: {
      Material: "Cotton",
      Quality: "Export Grade",
      Packing: "Bag of 20 Pcs",
    },
    applications: [
      "High Temperature Insulation",
      "Wire Harness",
      "Automotive",
      "Industrial Use",
    ],
  },

  {
    id: "pvc-roll-tape",
    name: "PVC Insulation Tape Roll",
    slug: "pvc-insulation-tape-roll",
    category: "Heat Shrink & Sleeves",
    subcategory: "PVC Tape",
    description:
      "PVC insulation tape roll for electrical and industrial insulation applications. Available in multiple sizes.",
    image: "/products/heat-shrink-sleeves/tape/pvc-insulation-tape-roll.jpg",
    variantType: "size",
    defaultVariant: "SI0501250",
    tags: ["pvc tape", "insulation", "electrical", "industrial"],
    applications: [
      "Electrical Insulation",
      "Wire Harness",
      "Automotive",
      "Industrial Use",
    ],

    variants: [
      {
        id: "pvc-medium",
        code: "SI0501250",
        name: "Medium",
        specifications: {
          Size: "Medium",
          Material: "PVC",
          Packing: "20 Pcs",
        },
      },
      {
        id: "pvc-big",
        code: "SI0502500",
        name: "Big",
        specifications: {
          Size: "Big",
          Material: "PVC",
          Packing: "20 Pcs",
        },
      },
      {
        id: "pvc-extra-big",
        code: "SI0505000",
        name: "Extra Big",
        specifications: {
          Size: "Extra Big",
          Material: "PVC",
          Packing: "20 Pcs",
        },
      },
      {
        id: "pvc-extra-ordinary-big",
        code: "SI0506000",
        name: "Extra Ordinary Big",
        specifications: {
          Size: "Extra Ordinary Big",
          Material: "PVC",
          Packing: "20 Pcs",
        },
      },
    ],
  },
];